import { useContext } from "react";

import { AsyncConfirmationModalContext } from "./AsyncConfirmationModalContext";
import type { AsyncConfirmationModalContextType } from "./types";

/**
 * A hook to use the async confirmation modal
 *
 * @returns The confirm function
 *
 * @example
 * const confirm = useAsyncConfirmationModal();
 *
 * await confirm({
 *   heading: "Are you sure?",
 *   body: "This action cannot be undone.",
 * });
 */
export const useAsyncConfirmationModal = (): AsyncConfirmationModalContextType["confirm"] => {
  const { confirm } = useContext(AsyncConfirmationModalContext);

  return confirm;
};
